// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__27FxQ","empty":"ModalGraph_empty__1lzYI"};